import imgFrame from '../../../assets/hero_image.png';
import { useInView } from '../../../hooks/useInView';
import styles from './HeroDeslogado.module.scss';

interface HeroDeslogadoProps {
  readonly onLogin: () => void;
}

export function HeroDeslogado({ onLogin }: HeroDeslogadoProps) {
  const [ref, inView] = useInView<HTMLDivElement>();

  return (
    <div className={styles.hero} data-name='hero-deslogado'>
      <div className={styles.imageFrame}>
        <div aria-hidden className={styles.bg}>
          <img alt='' className={styles.bgImg} src={imgFrame} />
          <div className={styles.overlay} />
        </div>

        <div
          ref={ref}
          className={`${styles.content} ${inView ? 'inView' : ''}`}
        >
          <div className={styles.textBlock}>
            <p className={styles.title}>
              PGRM: a nova plataforma digital da mineração brasileira.
            </p>
            <p className={styles.subtitle}>
              <span>{`A `}</span>
              <span className={styles.strong}>
                Plataforma de Gestão de Recursos Minerais
              </span>
              <span>{` foi criada para modernizar a relação entre a ANM e o setor mineral.`}</span>
            </p>
          </div>
          <button onClick={onLogin} className={styles.ctaGreen}>
            <i className='fas fa-city' aria-hidden='true' />
            <span>Acessar a PGRM</span>
          </button>
        </div>
      </div>
    </div>
  );
}
